import React from 'react';
import HeroSection from '../components/HeroSection';
import WhoSection from '../components/WhoSection';
import BenefitsSection from '../components/BenefitsSection';
import ProductFormats from '../components/ProductFormats';
import TrustSection from '../components/TrustSection';
import CTASection from '../components/CTASection';

const Home = () => {
  return (
    <>
      <HeroSection />
      <WhoSection />
      <BenefitsSection />
      <ProductFormats />
      <TrustSection />
      <CTASection />
    </>
  );
};

export default Home;